import styled from 'styled-components'

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
